import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./MyStyles.css";

function Menu() {

  const MenuCard = ({ link, title, icon, color }) => (
    <div className="col-xl-2 col-lg-3 col-md-4 col-sm-6 mb-4">

      <Link to={link} className="menu-link">

        <div className="menu-card" style={{ borderTop: `4px solid ${color}` }}>

          <div className="menu-icon" style={{ color: color }}>
            <FontAwesomeIcon icon={icon} size="2x" />
          </div>

          <p className="menu-title">{title}</p>

        </div>

      </Link>

    </div>
  );

  return (
    <section className="menu-section container-fluid mt-4">

      <div className="row">

        {/* HOME */}
        <MenuCard link="/" title="Home" icon="fa-solid fa-house" color="#0d6efd" />

        {/* ================= MASTER DATA ================= */}
        <MenuCard link="/add-const" title="Constituency" icon="fa-solid fa-city" color="#20c997" />
        <MenuCard link="/add-booth" title="Booth" icon="fa-solid fa-map-pin" color="#198754" />
        <MenuCard link="/add-streets" title="Streets" icon="fa-solid fa-road" color="#fd7e14" />
        <MenuCard link="/add-houses" title="Houses" icon="fa-solid fa-house-chimney" color="#6f42c1" />
        <MenuCard link="/add-voters" title="Voters" icon="fa-solid fa-users" color="#0dcaf0" />

        {/* ================= FIELD WORK ================= */}
        <MenuCard link="/booth-report" title="Booth Pulse" icon="fa-solid fa-check-to-slot" color="#6610f2" />
        <MenuCard link="/add-volunteers" title="Volunteers" icon="fa-solid fa-handshake" color="#198754" />
        <MenuCard link="/add-visits" title="Visits" icon="fa-solid fa-person-walking" color="#fd7e14" />
        <MenuCard link="/booth-daily-update" title="Daily Update" icon="fa-solid fa-calendar-day" color="#20c997" />

        {/* ================= ELECTION DAY ================= */}
        <MenuCard link="/booth-turnout" title="Turnout" icon="fa-solid fa-people-group" color="#0d6efd" />
        <MenuCard link="/election-incidents" title="Incidents" icon="fa-solid fa-triangle-exclamation" color="#dc3545" />

        {/* ================= ELECTION MANAGEMENT ================= */}
        <MenuCard link="/add-election" title="Election Master" icon="fa-solid fa-calendar" color="#6f42c1" />
        <MenuCard link="/add-party" title="Party Master" icon="fa-solid fa-flag" color="#dc3545" />
        <MenuCard link="/add-result" title="Constituency Result" icon="fa-solid fa-square-poll-vertical" color="#0dcaf0" />
        <MenuCard link="/add-party-vote" title="Party Votes" icon="fa-solid fa-chart-pie" color="#fd7e14" />

        {/* ================= DASHBOARD ================= */}
        <MenuCard link="/live-dashboard" title="Dashboard" icon="fa-solid fa-chart-line" color="#0d6efd" />

        {/* ================= UTILITIES ================= */}
        <MenuCard link="/news" title="News" icon="fa-regular fa-newspaper" color="#20c997" />
        <MenuCard link="/events" title="Events" icon="fa-regular fa-calendar-days" color="#198754" />
        <MenuCard link="/todolist" title="To-Do List" icon="fa-solid fa-list-check" color="#fd7e14" />

      </div>

    </section>
  );
}

export default Menu;